import flagsmith from 'flagsmith';

import {
  handleLinkClicks,
  handleScrollToFooter,
  sendPageViewEvent,
  handleButonClicks,
  sendEventOnScrollToElement
} from './clickstreamHandlers';
import clickStream, {clickstreamConfig} from './plugins/clickstream';
import { flagsmithConfig, isSignupDisabled } from './plugins/featureFlags';

clickStream.init(clickstreamConfig);

flagsmith.init(flagsmithConfig);

function applySignupVisibility() {
  const disabled = isSignupDisabled();

  document.querySelectorAll<HTMLElement>('[data-signup-link], [data-signup-block]').forEach((el) => {
    el.style.display = disabled ? 'none' : '';
  });

  document.querySelectorAll<HTMLElement>('[data-signup-grid]').forEach((el) => {
    el.toggleAttribute('data-signup-hidden', disabled);
  });
}

function scrollToElement(element: HTMLElement, behavior: ScrollBehavior = 'smooth') {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY,
    behavior
  });
}

(async function () {
  document.querySelectorAll('[data-target]').forEach(el => {
    el.addEventListener('click', () => {
      const target: HTMLElement | null = document.querySelector(el.getAttribute('data-target') || '');

      if (target) {
        scrollToElement(target);
      }
    });
  });

  applySignupVisibility();
  flagsmith.getFlags().then(applySignupVisibility).catch(() => {
    console.log('Error loading flags');
  });

  sendPageViewEvent();
  handleLinkClicks();
  handleButonClicks();
  handleScrollToFooter();
  sendEventOnScrollToElement();
})();

function initBottomsheet() {
  const SESSION_KEY = 'mobile-app-bs-shown';
  const CLOSE_DURATION = 300;

  if (window.innerWidth >= 768) return;
  if (sessionStorage.getItem(SESSION_KEY)) return;

  const section = document.querySelector<HTMLElement>('#bottomsheet');
  if (!section) return;

  const panel = section.querySelector<HTMLElement>('.bottomsheet__panel')!;
  const overlay = section.querySelector<HTMLElement>('.bottomsheet__overlay')!;
  const closeBtn = section.querySelector<HTMLElement>('.bottomsheet__close')!;
  const ctaLink = section.querySelector<HTMLElement>('.bottomsheet__btn')!;

  sessionStorage.setItem(SESSION_KEY, '1');
  section.classList.remove('hidden');
  section.classList.add('visible');
  document.body.style.overflow = 'hidden';

  function startClose() {
    section!.classList.add('bottomsheet--closing');
    panel.style.transition = `transform ${CLOSE_DURATION}ms ease`;
    panel.style.transform = 'translateY(100%)';
    setTimeout(() => {
      section!.classList.remove('visible', 'bottomsheet--closing');
      section!.classList.add('hidden');
      panel.style.transition = '';
      panel.style.transform = '';
      document.body.style.overflow = '';
    }, CLOSE_DURATION);
  }

  overlay.addEventListener('click', startClose);
  closeBtn.addEventListener('click', startClose);
  ctaLink.addEventListener('click', startClose);

  let startY = 0;
  let currentDeltaY = 0;
  let isDragging = false;

  panel.addEventListener('touchstart', (e) => {
    startY = e.touches[0].clientY;
    currentDeltaY = 0;
    isDragging = true;
    panel.style.transition = 'none';
  });

  panel.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const delta = e.touches[0].clientY - startY;
    if (delta <= 0) return;
    currentDeltaY = delta;
    panel.style.transform = `translateY(${delta}px)`;
  });

  panel.addEventListener('touchend', () => {
    if (!isDragging) return;
    isDragging = false;
    if (currentDeltaY >= 80) {
      startClose();
    } else {
      panel.style.transition = 'transform 0.25s ease';
      panel.style.transform = 'translateY(0)';
    }
    currentDeltaY = 0;
  });
}

document.addEventListener('DOMContentLoaded', () => {
    const stateKey = 'cookie-accepted';
    const cookieSection = document.querySelector('#cookie');
    const button = document.querySelector('#saveStateButton');

    if (!localStorage.getItem(stateKey)) {
      if (cookieSection && button) {
        cookieSection.classList.toggle('hidden');

        button.addEventListener('click', () => {
          localStorage.setItem(stateKey, JSON.stringify({saved: true}));
          cookieSection.classList.toggle('hidden');
        });
      }
    }

    initBottomsheet();
  }
)
